import { render, staticRenderFns } from "./PsychologyHistorialForm.vue?vue&type=template&id=225bd163&"
import script from "./PsychologyHistorialForm.vue?vue&type=script&lang=js&"
export * from "./PsychologyHistorialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports